class SmiffysSoldoutOverride extends HTMLElement{
    statusData=[];
    getSoldoutTextById(id) {
        let li = this.querySelector('li[value="' + id + '"]');
        let text = "";
        if (li.hasAttribute('data-soldout_text')) {
            text = li.getAttribute('data-soldout_text');
        }
        return text;
    }

    connectedCallback(){
        window.getSoldoutTextById = this.getSoldoutTextById.bind(this);
        document.addEventListener('variantchanged', (v)=>{
            let data = v.detail;
            this.updateSoldoutText(data.id);            
        });
        let prevSoldOut = document.querySelector('.badge.price__badge-sold-out');
        
        let dataSpan = this.querySelector('.product-status-data');
        if(dataSpan){
         let statusDataStr = dataSpan.getAttribute('data-status');
         if(statusDataStr){
            this.statusData = JSON.parse(statusDataStr);
            this.updateSoldoutOverrideLis();

         }
        }

        let selected = this.querySelector('li.selected');
        if(selected){
            this.updateSoldoutText(selected.getAttribute('value'));            
        }
    }

    updateSoldoutOverrideLis(){
        let soldoutText = this.getAttribute('data-soldout_text');
        let comingsoonText = this.getAttribute('data-comingsoon_text');
        for(const li of this.querySelectorAll('ul.soldout_override--data li')){
            let sku = li.getAttribute('data-sku');
            let available = li.getAttribute('data-available');
            let dataItem = this.statusData.find(p=> p.Sku === sku);
            if(dataItem && available=="false"){
                if(dataItem.DueDate){
                    li.setAttribute('data-eta', dataItem.DueDate);
                }
                if(dataItem.ItemStatusCode == "BRANDED" || dataItem.ItemStatusCode == "COLLECTION"){
                    li.setAttribute('data-soldout_text', comingsoonText);
                }
                else{
                    li.setAttribute('data-soldout_text', soldoutText);
                }                
            }
        }
    }

    updateAdditionalUi(productStatusMessage){
        let productWrapper = this.closest('.product__info-wrapper');
        let button = productWrapper.querySelector('button.product-form__submit');
        if(button && productStatusMessage.length > 0){
            button.innerHTML = `<span>${productStatusMessage}</span>`
        }

        let productAccessories = productWrapper.querySelector('smiffys-product-accessories');
        if(productAccessories){
            if(productStatusMessage.length > 0){
                productAccessories.classList.add('hidden');
            }else{
                productAccessories.classList.remove('hidden');
            }
        }

    }

    updateSoldoutText(id){
        let text = this.getSoldoutTextById(id);
        this.querySelector('.soldout-text').innerHTML = text;
        setTimeout(() => {
            this.updateAdditionalUi(text);
        }, 10);
    }

    
}
customElements.define('smiffys-soldout-override', SmiffysSoldoutOverride);